import { render, staticRenderFns } from "./GradeEngagementTab.vue?vue&type=template&id=36224e87"
import script from "./GradeEngagementTab.vue?vue&type=script&lang=js"
export * from "./GradeEngagementTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports